module.exports = __webpack_public_path__ + "img/proses_banding.a1f50bef.svg";